<template>
  <div class="min-h-screen bg-white">
    <!-- 顶部Banner区 -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/product/Group 24.jpg" alt="精准控温控湿" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">精准控温控湿</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          通过模拟自然生态环境，打破传统农业对气候与地域的依赖，实现菌菇生产的工业化、可控化与高效化 —— 现代农业智慧转型的核心载体。</p>
      </div>
    </section>

    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg2.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>
      
      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">JF-A 系列智能化立体仿生仓</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          拥有智能仿生蘑菇仓系统
        </p>
      </div>
      <!-- 底部两个按钮卡片 -->
      <div class="w-full grid grid-cols-2 gap-2 absolute bottom-0 left-0 z-10">
  
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/2')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">蘑菇仓</p>
            <p class="text-[8px] whitespace-nowrap">Mushroom Growing Chamber</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/1')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">菌菇</p>
            <p class="text-[8px]">Mushroom</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
      </div>
    </section>
    <!-- 产品型号介绍区 -->
    <section class="py-16 md:max-w-[56%] max-w-[94%] mx-auto flex items-center">
      <div class="md:hidden text-[24px] font-bold text-[#333] mb-7 text-center">
        <img class="w-[18px] h-[18px]" src="@/assets/home/mb_icon.png" alt="" />
        <div class="mt-2">智能仿生蘑菇仓</div>
      </div>
      <!-- 产品图 -->
      <div class="flex justify-center flex-[3]">
        <img src="@/assets/home/Rectangle_11.png" alt="JF-A培养仓" class="mx-auto md:w-4/5 w-[100%] h-auto" />
      </div>
      <!-- 型号参数 -->
      <div class="flex-[2] hidden md:block">
        <!-- JF-A48 -->
        <div class="mb-8">
          <img src="@/assets/product/icon.png" alt="JF-A48智能化仿生仓" class="md:hidden w-[100%] h-auto mr-3" />
          <h3 class="md:text-3xl text-[16px] font-bold text-[#41B56F] mb-3">JF-A48智能化立体仿生仓</h3>
          <div class="flex gap-3 mb-3">
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#41B56F] text-[#41B56F] rounded-full text-[14px]">智能监控</span>
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#FBC02D] text-[#FBC02D] rounded-full text-[14px]">控温控湿</span>
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#1976D2] text-[#1976D2] rounded-full text-[14px]">省能环保</span>
          </div>
          <p class="text-[#333333] text-[16px]">仿生仓48平米（长宽高：12*4*4.2m）</p>
        </div>
        <!-- 分割线 -->
        <div class="w-full h-[1px] bg-[#999999] mb-8"></div>

        <!-- JF-A60 -->
        <div>
          <h3 class="text-3xl font-bold text-[#41B56F] mb-3">JF-A60智能化仿生仓</h3>
          <div class="flex gap-3 mb-3">
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#41B56F] text-[#41B56F] rounded-full text-[14px]">智能监控</span>
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#FBC02D] text-[#FBC02D] rounded-full text-[14px]">控温控湿</span>
            <span
              class="px-3 py-1 border border-[1px] border-solid  border-[#1976D2] text-[#1976D2] rounded-full text-[14px]">省能环保</span>
          </div>
          <p class="text-[#333333] text-[16px]">仿生仓60平米（长宽高：12*5*4.5m）</p>
        </div>
      </div>
      <div class="flex-[2] md:hidden block">
        <!-- JF-A48 -->
        <div class=" mb-3">
          <div class="flex items-center">
            <img src="@/assets/product/icon.png" alt="JF-A48智能化仿生仓" class="md:hidden w-[18px] h-[18px] mr-1" />
            <h3 class="md:text-3xl text-[16px] font-bold text-[#41B56F]">JF-A48智能化立体仿生仓</h3>
            <div class="flex gap-1 ml-1">
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#41B56F] text-[#41B56F] rounded-full text-[6px]">智能监控</span>
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#FBC02D] text-[#FBC02D] rounded-full text-[6px]">控温控湿</span>
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#1976D2] text-[#1976D2] rounded-full text-[6px]">省能环保</span>
            </div>
          </div>
        </div>
        <p class="text-[#333333] text-[8px] mb-8 ">仿生仓48平米（长宽高：12*4*4.2m）</p>
        <div class=" mb-3">
          <div class="flex items-center">
            <img src="@/assets/product/icon.png" alt="JF-A48智能化仿生仓" class="md:hidden w-[18px] h-[18px] mr-1" />
            <h3 class="md:text-3xl text-[16px] font-bold text-[#41B56F]">JF-A60智能化仿生仓</h3>
            <div class="flex gap-1 ml-1">
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#41B56F] text-[#41B56F] rounded-full text-[6px]">智能监控</span>
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#FBC02D] text-[#FBC02D] rounded-full text-[6px]">控温控湿</span>
              <span
                class="px-2 py-1 border border-[1px] border-solid  border-[#1976D2] text-[#1976D2] rounded-full text-[6px]">省能环保</span>
            </div>
          </div>
        </div>
        <p class="text-[#333333] text-[8px] ">仿生仓60平米（长宽高：12*5*4.5m）</p>
      </div>
    </section>
    <div class="max-w-[56%] h-[1px] mx-auto bg-[#999999] mt-4 mb-20 hidden md:block "></div>
    <!-- 下方功能模块整图区 -->
    <section class=" md:max-w-[56%] max-w-[94%] mx-auto py-8">
      <img src="@/assets/product/Rectangle_21.png" alt="七大功能模块" class="w-full h-auto rounded-lg">
    </section>
  </div>
</template>


<script>
export default {
  name: "Product2Detail",
  methods: {
    goPage(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
@media (max-width: 1200px) {
  .py-16 {
    padding: 80px 5%;
  }

  .gap-16 {
    gap: 40px;
  }
}

@media (max-width: 768px) {
  section:first-child {
    height: 400px;
  }

  section:first-child h1 {
    font-size: 32px;
  }

  .py-16 {
    flex-direction: column;
    padding: 40px 5%;
  }

  .fixed {
    right: 2%;
  }
}
</style>